import React from 'react';

const AnalyticsSummaryCards = ({ summary }) => {
    return (
        <div className="analytics-summary-row">
            <div className="analytics-summary-card total-calls">
                <div className="card-title">Total API Calls</div>
                <div className="card-value">{summary?.totalCalls || 0}</div>
            </div>
            <div className="analytics-summary-card success-rate">
                <div className="card-title">Success Rate</div>
                <div className="card-value">{summary?.successRate || 0}%</div>
            </div>
            <div className="analytics-summary-card error-rate">
                <div className="card-title">Error Rate</div>
                <div className="card-value">{summary?.errorRate || 0}%</div>
            </div>
            <div className="analytics-summary-card response-time">
                <div className="card-title">Avg Response Time</div>
                <div className="card-value">{summary?.avgResponseTime || 0} ms</div>
            </div>
            <div className="analytics-summary-card unique-users">
                <div className="card-title">Unique Users</div>
                <div className="card-value">{summary?.uniqueUsers || 0}</div>
            </div>
        </div>
    );
};

export default AnalyticsSummaryCards;
